import { SVGInterface } from "../../interface";

const Refresh = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12.0116 3.00001C7.33358 2.99361 3.43082 6.57254 3.03301 11.2336C2.6352 15.8947 5.87503 20.0833 10.4865 20.8697C15.098 21.6561 19.5429 18.7781 20.7124 14.2486H18.3716C17.2273 17.485 13.8362 19.3469 10.4913 18.5753C7.1465 17.8037 4.91365 14.6444 5.30275 11.2339C5.69185 7.82331 8.57894 5.2481 12.0116 5.24973C13.7996 5.25235 15.5115 5.9739 16.7619 7.25198L13.1421 10.874H21.0161V3.00001L18.3716 5.64344C16.6885 3.9501 14.3991 2.99857 12.0116 3.00001Z"
      fill={color || "#2D2D2D"}
    />
  </svg>
);

export default Refresh;
